<template>
  <div class="wrapper">
    <div class="container">
      <div class="auth-result">
        <img src="../assets/images/ic-auth-succes.png" class="icon" />
        <h3>授权成功</h3>
        <!-- <p>请您及时在奇点群告诉我们~</p> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'storeList',
  data() {
    return { }
  },
  created() {
    
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.auth-result{
  .icon{
    width: 136px;
    height: 136px;
    display: block;
    margin: 100px auto 0;
  }
  h3{
    width: 100%;
    line-height: 1.4;
    font-size: 24px;
    color: #222;
    font-weight: bold;
    text-align: center;
    margin: 12px auto 10px;
  }
  p{
    line-height: 1.4;
    font-size: 16px;
    color: #666;
    text-align: center;
  }
}
@media screen and (max-width:750px){
  .container{
    width: 94%;
    margin: 0 3%;
  }
}
@media screen and (min-width:750px){
  .wrapper .container {
    height: 100%;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/views/auth.vue